import React from 'react'
import { Button, Result } from 'antd'
import { Well } from '@pushly/aqe/lib/components'
import { useService } from '@pushly/aqe/lib/hooks'
import { AppService } from '../../services'

import './feeds-moved-redirect-card.scss'
import { FeatureAnticon } from '../icons/feature-icon'

const FEEDS_LIST_PATH = '/feeds'

/**
 * Legacy Notifications → Feeds tab body.
 *
 * Feeds has been promoted to a top-level navigation item; this card replaces
 * the old in-tab feed list and points users to the new home. The tab remains
 * present (respecting existing FEED read access) and will be removed in a
 * future release.
 */
export const FeedsMovedRedirectCard = () => {
    const appService = useService(AppService)

    return (
        <Well hideHeader={true} footerMode="hidden">
            <Result
                // antd colors the Result icon on its `.anticon` child for the default
                // `info` status; an inline style lands on that exact element and wins
                // without a specificity fight or `!important`. The Feeds icon is
                // stroke-based (stroke="currentColor"), so it inherits that colour. `--color-gray-dark` is the mode-aware muted grey — this is
                // a deprecation signpost, so the icon stays de-emphasized rather than accented.
                icon={
                    <FeatureAnticon slot="nav:feeds" aria-hidden="true" style={{ color: 'var(--color-gray-dark)' }} />
                }
                title="Feeds has moved"
                subTitle="Feeds now has its own home in the left navigation. You'll find the same feeds there — plus the ability to use them as content in Journeys."
                extra={[
                    <Button
                        key="go-to-feeds"
                        type="primary"
                        onClick={() => appService.routeWithin('domain', FEEDS_LIST_PATH)}
                    >
                        Go to Feeds
                    </Button>,
                    <div key="footer-note" className="feeds-moved-footer-note">
                        This tab will be removed in a future release.
                    </div>,
                ]}
            />
        </Well>
    )
}

export default FeedsMovedRedirectCard
